export default __webpack_public_path__ + "static/media/icon-font.cc7c4f83.woff2";